import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'backlog.modals.board-issue-move-dialog.title',
		defaultMessage: "Fill your backlog with to-do's",
		description: '',
	},
	description: {
		id: 'backlog.modals.board-issue-move-dialog.description',
		defaultMessage: "Want to move all issues in your board's first column to the backlog?",
		description: '',
	},
	confirm: {
		id: 'backlog.modals.board-issue-move-dialog.confirm',
		defaultMessage: 'Yes, move',
		description: '',
	},
	cancel: {
		id: 'backlog.modals.board-issue-move-dialog.cancel',
		defaultMessage: 'No thanks',
		description: '',
	},
});
